<!--Banner: 体验中心-banner 2020/08/26 13:59:44 Sunanguang-->

<template>
  <el-carousel class="its-banners" :height="height" :arrow="carouselSet.arrow" :indicator-position="showIndicator">
      <el-carousel-item class="its-banner" v-for="(banner,i) in banners" :key="i">
        <div class="its-background" :style="'background: #4390ff url(images/experience_bg_'+banner.key+'.png)'"></div>
        <img  class="its-src" :src="'images/experience_src_'+banner.key+'.png'">
        <div v-if="banner.mainTitle" class="its-main-title" v-html="banner.mainTitle"></div>
        <div v-if="banner.subTitle" class="its-sub-title" v-html="banner.subTitle"></div>
        <div v-if="banner.desc" class="its-desc-title" v-html="banner.desc"></div>
        <slot></slot>
      </el-carousel-item>
    </el-carousel>
</template>
<script>
export default {
  name: 'Banner',
  props: {
    height: {
      type: String,
      default: function () {
        return '700px'
      }
    },
    banners: {//banner列表
      type: Array,
      default: function () {
        return []
      }
    },
    carouselSet: {
      type: Object,
      default: function () {
        return {
          arrow: 'never',//箭头显示
        }
      }
    }
  },
  data () {
    return {
      showIndicator:'outside'
    }
  },
  mounted () {
    if(this.banners.length==1){
      this.showIndicator = 'none'
    }
  },
  methods:{
    toDetial:function(url){
      this.$router.push({name:url})
    }
  }
}
</script>
<style scoped>
.its-banners{
  height: auto;
  position: relative;
  z-index: 1;
}
.its-background{
  height: 775px;
  width: 100%;
  background-color: red;
  background-position: center !important;
  background-repeat: no-repeat !important;
  background-size: cover !important;
}
.its-main-title{
  position: absolute;
  left: 18.75%;
  top: 370px;
  line-height: 1;
  font-size: 48px;
  color: white;
  font-weight: 600;
}
.its-sub-title{
  position: absolute;
  left: 18.75%;
  top: 316px;
  line-height: 1;
  font-size: 30px;
  color: white;
}
.its-desc-title{
  position: absolute;
  left: 18.75%;
  top: 460px;
  line-height: 1.8;
  font-size: 20px;
  color: white;
}
.its-button{
  width:140px;
  height:52px;
  border-radius: 26px;
  background: white;
  text-align: center;
  line-height: 52px;
  cursor: pointer;
}
.its-btn-more{
  position: absolute;
  left: 18.75%;
  bottom: 195px;
  font-size: 18px;
  color: #3C81FF;
  font-weight: normal;
}
.its-btn-more:hover span{
  opacity: 0.8;
}
.its-src{
  position: absolute;
  bottom: 0;
}
@media screen and (max-width: 960px){
  .its-src{
    position: absolute;
    right: 8%;
    width: 350px;
  }
}
@media screen and (min-width: 960px) and (max-width: 1280px){
  .its-src{
    position: absolute;
    right: 4.67%;
    width: 560px;
    bottom: 102px;
  }
}
@media screen and (min-width: 1280px) and (max-width: 1560px){
  .its-src{
    position: absolute;
    right: 3.92%;
    bottom: 62px;
    width: 771px;
  }
}
@media screen and (min-width: 1560px){
  .its-src{
    position: absolute;
    right: 2.92%;
    bottom: 42px;
  }
}

</style>
